import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useLayoutEffect, useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import DropDown from '../ui/react-ui/dropdown';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { getStatsGates } from '../../api/statsAPI';
import { setStatsGatesForPie, setStatsGatesPieSelected } from '../../redux/stats-dashboard';
var t = i18n.getFixedT(null, 'stats-dashboard');
var StatsGatesPieChart = /*#__PURE__*/React.memo(function (_ref) {
  var isFullScreen = _ref.isFullScreen;

  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$statsDas = _useSelector.statsDashboard,
      statsGatesForPie = _useSelector$statsDas.statsGatesForPie,
      dateTime = _useSelector$statsDas.dateTime,
      statsGatesPieSelected = _useSelector$statsDas.statsGatesPieSelected,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();

  var _useState = useState(isFullScreen),
      _useState2 = _slicedToArray(_useState, 2),
      isChangeScreen = _useState2[0],
      setIsChangeScreen = _useState2[1];

  var pieChart = useRef();
  var label1 = useRef();
  var label2 = useRef();
  var isMounted = useRef(false);

  var calChartTotalCountObj = function calChartTotalCountObj(key) {
    var obj = {
      totalCount: 0,
      totalEntryCount: 0,
      totalExitCount: 0
    };

    _.map(statsGatesForPie, function (el) {
      obj.totalCount += Number(el.totalCount);
      obj.totalEntryCount += Number(el.entryCount);
      obj.totalExitCount += Number(el.exitCount);
    });

    return key ? obj[key] : obj;
  };

  useLayoutEffect(function () {
    pieChart.current = am4core.create('statsGatesChart', am4charts.PieChart);
    pieChart.current.innerRadius = am4core.percent(60);
    am4core.addLicense;
    pieChart.current.hiddenState.properties.opacity = 0; // this creates initial fade-in
    // let colorSet = new am4core.ColorSet()
    // Add and configure Series

    var pieSeries = pieChart.current.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "gate";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.labels.template.disabled = true; // pieSeries.colors = colorSet
    // Set up labels

    label1.current = pieChart.current.seriesContainer.createChild(am4core.Label);
    label1.current.text = t('lbl-total-count', {
      count: calChartTotalCountObj('totalCount')
    });
    label1.current.horizontalCenter = "middle";
    label1.current.fontSize = 20;
    label1.current.fontWeight = 500;
    label1.current.dy = -16;
    label2.current = pieChart.current.seriesContainer.createChild(am4core.Label);
    label2.current.text = t('lbl-entry-exit-count', {
      entryCount: calChartTotalCountObj('totalEntryCount'),
      exitCount: calChartTotalCountObj('totalExitCount')
    });
    label2.current.horizontalCenter = "middle";
    label2.current.fontSize = 14;
    label2.current.dy = 14; // Add a legend

    pieChart.current.legend = new am4charts.Legend();
    pieChart.current.legend.position = "right";
    pieChart.current.legend.scrollable = true;
    pieChart.current.legend.maxWidth = '100';
    pieChart.current.legend.fontSize = '12'; // pieChart.current.data = _.map(statsGatesForPie, el => {
    //     console.log('insert 1')  
    //     return {
    //     gate: el.gateName,
    //     value: el.totalCount
    // }})

    pieChart.current.data = _.map(statsGatesForPie, function (el) {
      return {
        gate: el.gateName,
        value: el.totalCount
      };
    }); // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    isMounted.current = true;
    return function () {
      pieChart.current.dispose();
    };
  }, [JSON.stringify(statsGatesForPie)]); // useEffect(() => {
  //     if(!isMounted.current)
  //         return
  //     // update labels
  //     label1.current.text = t('lbl-total-count', {
  //         count: calChartTotalCountObj('totalCount')
  //     })
  //     label2.current.text = t('lbl-entry-exit-count', {
  //         entryCount: calChartTotalCountObj('totalEntryCount'),
  //         exitCount: calChartTotalCountObj('totalExitCount')
  //     })
  //     // update pie data
  //     pieChart.current.data = _.map(statsGatesForPie, el => ({
  //         gate: el.gateName,
  //         value: el.totalCount
  //     }))
  // }, [JSON.stringify(statsGatesForPie)])

  useEffect(function () {
    if (isChangeScreen === isFullScreen || !isMounted.current) return;
    pieChart.current.data = [];
    setTimeout(function () {
      pieChart.current.data = _.map(statsGatesForPie, function (el) {
        return {
          gate: el.gateName,
          value: el.totalCount
        };
      });
    }, 100);
    setIsChangeScreen(isFullScreen);
  }, [isFullScreen]);

  var handleChange = function handleChange(zoneId) {
    dispatch(setStatsGatesPieSelected(zoneId));
    getStatsGates(contextRoot, false, zoneId, dateTime).then(function (data) {
      dispatch(setStatsGatesForPie(_.isEmpty(data.content) ? 'noData' : data.content));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "chart-dropdown"
  }, /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals-center'),
    list: zonesList,
    value: statsGatesPieSelected,
    onChange: handleChange,
    width: "200px"
  })), statsGatesForPie === 'noData' ? /*#__PURE__*/React.createElement("div", {
    className: "stats-gates-chart-nodata"
  }, t('lbl-no-data')) : /*#__PURE__*/React.createElement("div", {
    id: "statsGatesChart",
    className: "chart-block"
  }));
});
export default StatsGatesPieChart;